<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
  >
    <rect x="1.5" y="1.5" width="8" height="4" rx="0.5"
      fill="none" stroke="currentColor" stroke-width="1"
      stroke-linecap="round" stroke-linejoin="round" />
    <rect x="11.5" y="1.5" width="8" height="4" rx="0.5"
      fill="none" stroke="currentColor" stroke-width="1"
      stroke-linecap="round" stroke-linejoin="round" />
    <rect x="1.5" y="8.5" width="8" height="4" rx="0.5"
      fill="none" stroke="currentColor" stroke-width="1"
      stroke-linecap="round" stroke-linejoin="round" />
    <rect x="11.5" y="8.5" width="8" height="4" rx="0.5"
      fill="none" stroke="currentColor" stroke-width="1"
      stroke-linecap="round" stroke-linejoin="round" />
    <rect x="1.5" y="15.5" width="8" height="4" rx="0.5"
      fill="none" stroke="currentColor" stroke-width="1"
      stroke-linecap="round" stroke-linejoin="round" />
    <rect x="11.5" y="15.5" width="8" height="4" rx="0.5"
      fill="none" stroke="currentColor" stroke-width="1"
      stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>

<script setup lang="ts"></script>
